import React from 'react';
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
//
// import './styles.css';

export default function MyTicket() {
  useHubspotForm({
    portalId: '20447775',
    formId: 'a44ebe90-ad55-47f7-9871-9b72a05d5ba9',
    target: '#my-hubspot-form',
  });

  return (
    <div className="App mt-4 p-4 bg-white rounded-sm shadow">
      <div id="my-hubspot-form" />
    </div>
  );
}
